export default __webpack_public_path__ + "static/media/logoGithub.865b75ba.png";